export const SUPPORT_LINK = "Support";
export const SUPPORT_LINK_URL = "https://support-link-url.com";
export const FAQS_LINK =
  "https://help.hopper.com/en_us/categories/help-with-flights-Hywr1lPz_";
